import { gsap } from 'gsap';

const STORAGE_KEY = 'email-popup-hidden';

const selectors = {
  container: '[data-container]',
  popup: '[data-popup]',
  backdrop: '[data-backdrop]',
  closeButton: '[data-close]',
  successMessage: '[data-success]',
  errorMessage: '[data-error]',
}

class EmailPopup extends HTMLElement {
  #delay = 0;

  constructor() {
    super();

    this.onClose = this.onClose.bind(this);
    this.handleEscape = this.handleEscape.bind(this);
  }

  popupIsHidden() {
    const isHidden = localStorage.getItem(STORAGE_KEY);
    return isHidden === 'true';
  }

  onClose() {
    this.setAttribute('inert', '');

    document.body.classList.remove('overflow-clip');

    const tl = gsap.timeline();

    tl.to(this.container, {
      autoAlpha: 0,
      duration: 0.85,
      ease: 'power2.out',
    }, 0);

    tl.to(this.popup, {
      scale: 0.95,
      opacity: 0,
      duration: 0.85,
      ease: 'elastic.out(1, 0.975)',
      onComplete: () => {
        localStorage.setItem(STORAGE_KEY, 'true');
        this.remove();
      }
    }, '<')
  }

  showPopup() {
    this.removeAttribute('inert');

    document.body.classList.add('overflow-clip');

    const tl = gsap.timeline();

    tl.from(this.container, {
      autoAlpha: 0,
      duration: 0.85,
      delay: this.#delay,
      ease: 'power2.out',
    }, 0);

    tl.from(this.popup, {
      scale: 0.975,
      opacity: 0,
      duration: 0.85,
      ease: 'elastic.out(1, 0.975)'
    }, '<+=0.15')
  }

  handleEscape(event) {
    if (event.key === 'Escape') {
      this.onClose();
    }
  }

  connectedCallback() {
    this.#delay = Number(this.getAttribute('data-delay') ?? 0);

    this.closeButtons = Array.from(this.querySelectorAll(selectors.closeButton));
    this.successMessage = this.querySelector(selectors.successMessage);
    this.errorMessage = this.querySelector(selectors.errorMessage);
    this.container = this.querySelector(selectors.container);
    this.popup = this.querySelector(selectors.popup);
    this.backdrop = this.querySelector(selectors.backdrop);

    this.closeButtons.forEach(button => {
      button.addEventListener('click', this.onClose);
    });

    if (!this.popupIsHidden()) {
      this.showPopup();
      window.addEventListener('keydown', this.handleEscape);
    }
  }

  disconnectedCallback() {
    this.closeButtons.forEach(button => {
      button.removeEventListener('click', this.onClose);
    });

    window.removeEventListener('keydown', this.handleEscape);
  }
}

if (!customElements.get('email-popup')) {
  customElements.define('email-popup', EmailPopup);
}